var $7541adb5b7004905$exports = {};
let $7541adb5b7004905$var$lastScrollY = window.scrollY;
const $7541adb5b7004905$var$threshold = 100;
const $7541adb5b7004905$var$addScrollListener = ()=>{
    window.addEventListener('scroll', ()=>{
        const header = document.querySelector('header');
        if (Math.abs(window.scrollY - $7541adb5b7004905$var$lastScrollY) > $7541adb5b7004905$var$threshold) {
            if (window.scrollY > $7541adb5b7004905$var$lastScrollY) header.classList.add('hidden');
            else header.classList.remove('hidden');
            $7541adb5b7004905$var$lastScrollY = window.scrollY;
        }
    });
};
document.addEventListener('DOMContentLoaded', ()=>{
    $7541adb5b7004905$var$addScrollListener();
});


//# sourceMappingURL=about.dcc15f5c.js.map
